/**
 * SettlementHeader – Dark navy gradient header for settlement screens.
 * Figma: "End of an era." logo on left, ExecutorBadge on right.
 * Below: centered "{Name}'s Estate Settlement" subtitle bar.
 */

import settlementLogoLight from '../../assets/images/settlement-logo-light.svg';
import ExecutorBadge from '../settlement/ExecutorBadge';
import { useSettlement } from '../../contexts/SettlementContext';

export default function SettlementHeader() {
  let estateName = 'Your Loved One';
  try {
    const ctx = useSettlement();
    if (ctx.estate?.ownerName) {
      estateName = ctx.estate.ownerName;
    }
  } catch {
    // Not inside SettlementProvider — use default
  }

  return (
    <header id="app-header" className="w-full">
      {/* Main header bar — dark navy gradient */}
      <div className="bg-dark-gradient px-5">
        <div className="h-[60px] flex items-center justify-between">
          {/* Logo — light version with colored icon + cream text on dark bg */}
          <div className="flex items-center">
            <img
              src={settlementLogoLight}
              alt="End of an Era"
              className="h-5 w-auto object-contain"
            />
          </div>

          {/* Executor badge */}
          <ExecutorBadge estateName={estateName} />
        </div>
      </div>

      {/* Subtitle bar */}
      <div className="bg-white border-b border-grey-300 py-2 px-5">
        <p className="text-center text-sm font-medium text-blue-900 tracking-wide">
          {estateName}'s Estate Settlement
        </p>
      </div>
    </header>
  );
}
